import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  FormGroup,
  Label,
  Row,
  Col,
} from "reactstrap";

import API from "utils/API";
import { default as ReactSelect } from "react-select";

import Select from "react-select";
import { Formik } from "formik";
import { Option, LimitedChipsContainer } from "components/Options";

import * as Yup from "yup";
import ThirdPartyAdmin from "components/ThirdPartyAdmin";
import reseticon from "assets/icon/reset.svg";
import searchicon from "assets/icon/search.svg";
import configicon from "assets/icon/config-icon.svg";
import useContextService from "hooks/useContextService";
import { cloneDeep } from "lodash";
import { ModuleAccess } from "utils/moduleaccess";
const initialValues = {
  coveredEntityID: '',
  pharmacyID: '',
  thirdPartyAdminID: '',
};

const validationSchema = Yup.object({
  thirdPartyAdminID: Yup.string().required("Third Party Administrator is required"),
  coveredEntityID: Yup.string().required("Chain Pharmacy is required"),
  // pharmacyID: Yup.string().required("Pharmacy is required"),
});
let chainpharmacydata=[]
let chainPharmacyError = "";
let thirdPartyAdminError = "";
let isValid=false;
let isTPADisable = true;
let isCPDisable = true;
const SearchConfiguration = (props
) => {
  const {
    states: { configurations },
    setStates,
    resetStates,
  } = useContextService();
  const { onSearch, onReset, refetch, setClientCongigToggle,
    rowconfig,
    setRowConfig,
    setConfigRules,
    SelectedChainPharmacy,
    setSelectedChainPharmacy,
    setSelectChainPharmacyName,
  } = props;
  const {
    thirdPartyAdmin,
    chainpharmacies,
    coveredEntities,
    searchTerms,
    coveredEntity,
    chainpharmacy,
    enableAdd
  } = configurations;
  const { thirdPartyAdminID, coveredEntityID, pharmacyID, ceIds } = searchTerms;
  const { tenantID } = thirdPartyAdmin;
  console.log(configurations, "config")
  const formikRef = useRef();
  const [ceLoading, setCeLoading] = useState(false);
  // const[thirdPartyAdminID,setTpaID]=useState('');
  const [selectedTpa, setSelectedTpa] = useState({});
  const [chainPharmacyList, setChainPharmcyList] = useState([]);
  const [searchCEterm, setSearchCEterm] = useState('');
  const [selectedCE, setSelectedCE] = useState(null);
  const [phList, setPHList] = useState([]);
  const [searchPHterm, setSearchPHterm] = useState('');
  const [selectedPH, setSelectedPH] = useState(null);
  const [isDisable, setIsDisable] = useState(false);
  const [selectedOption, setOptionSelected] = useState({
    optionSelected: "-1",
  });
  useEffect(() => {
    onReset();
    resetStates("configurations");
    setOptionSelected({ optionSelected: "-1" });
    configurations.searchTerms.chainPharmacyIds = "";
    setSelectedTpa({});
    setChainPharmcyList([]);
    setSelectedCE(null);
    setPHList([]);
    setSelectedPH(null);
    isTPADisable = true;
    isCPDisable = true;
    chainPharmacyError = "";
    thirdPartyAdminError = "";
  }, [])

  const handleThirdPartyAdminChange = async (value, setFieldValue, tpa) => {
    setOptionSelected({ optionSelected: "-1" });
    configurations.chainpharmacy = "";
    configurations.searchTerms.chainpharmacyID = "";
    if (tpa) {
      const { thirdPartyAdminID } = tpa;
      setFieldValue('thirdPartyAdminID', thirdPartyAdminID)
      setSelectedTpa(tpa);
      configurations.chainpharmacy = "";
      configurations.searchTerms.chainpharmacyID = "";
      configurations.thirdPartyAdmin = tpa;
      configurations.searchTerms.thirdPartyAdminID = thirdPartyAdminID;
      // setTpaID(thirdPartyAdminID);
      setChainPharmcyList([]);
      setSelectedCE(null);
      setPHList([]);
      setSelectedPH(null);
      isTPADisable = false;
      thirdPartyAdminError = "";
      fetchChainPharmacies(thirdPartyAdminID);
    } else {
      thirdPartyAdminError = "Third Party Administrator is required";
      setFieldValue('thirdPartyAdminID', '');
      setFieldValue('coveredEntityID', '');
      setFieldValue('pharmacyID', '');
      setSelectedTpa({});
      setOptionSelected({ optionSelected: "-1" });
      setChainPharmcyList([]);
      configurations.chainpharmacy = "";
      configurations.searchTerms.pharmacyID = "";
      configurations.thirdPartyAdmin = {};
      configurations.searchTerms.thirdPartyAdminID = "";
      // setTpaID('');
      setSelectedCE(null);
      setPHList([]);
      setPHList([]);
      setSelectedPH(null);
      isTPADisable = true;
      isCPDisable = true;
    }
  };

  const fetchChainPharmacies = async (thirdPartyAdminID) => {
    try {
      chainpharmacydata = [];

      const { data } = await API.get(
        `GWConfig/coveredentity/ChainPharmacieslist/${thirdPartyAdminID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          chainpharmacydata.push({ value: data[x].id, label: data[x].description });
        }
        setChainPharmcyList(chainpharmacydata);
        setSearchCEterm('');
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const findCE = async (value) => {
    setSearchCEterm(value);
  };
  const updateStates = (configurations) => {
    setStates("configurations", configurations);
  };

  const onSelectCP = (selected) => {
    if (selected !== null) {
      chainPharmacyError = "";
      isCPDisable = false;
      setSelectedChainPharmacy(selected.value)
      setSelectChainPharmacyName(selected) ;
      configurations.searchTerms.chainpharmacyID = selected.value
      setOptionSelected({
        optionSelected: selected,
      });
      setSelectedCE(selected);
      updateStates(configurations)
    } else {
      isCPDisable = true;
      setOptionSelected({
        optSelected: -1,
      });
      setSelectedChainPharmacy("");
      setSelectChainPharmacyName("") ;
      configurations.searchTerms.chainpharmacyID = "";
      chainPharmacyError = "Chain Pharmacy is required";
    }
  };

  const handleSubmit = async (val, actions) => {
    let chainPharmacyIds = [];
    chainPharmacyIds.push(val.chainpharmacyID);
    const { setSubmitting } = actions;
    const values = cloneDeep(val);
    if (thirdPartyAdminID) values.thirdPartyAdminID;
    if (chainPharmacyIds > [0]) values.chainpharmacyID = chainPharmacyIds;
    if (val.thirdPartyAdminID == "") {
      isValid = true;
      thirdPartyAdminError = "Third Party Administrator is required";
    } else {
      isValid = false;
      thirdPartyAdminError = "";
    }
    if (val.chainpharmacyID == "" || val.chainpharmacyids.length == 0) {
      isValid = true;
      chainPharmacyError = "Chain Pharmacy is required";
    } else {
      isValid = false;
      chainPharmacyError = "";
    }
    if (!isValid) {
      configurations.search.currentPage = 1;
      updateStates(configurations);
      setRowConfig(true);
      setClientCongigToggle(false);
      setConfigRules(false)
      await onSearch(values);
    }
    setSubmitting(false);
  };
  const handleReset = ({ resetForm }) => {
    resetForm();
    onReset();
    resetStates("configurations");
    setOptionSelected({ optionSelected: "-1" });
    configurations.searchTerms.chainPharmacyIds = "";
    setSelectedTpa({});
    setChainPharmcyList([]);
    setSelectedCE(null);
    setPHList([]);
    setSelectedPH(null);
    isTPADisable = true;
    isCPDisable = true;
    chainPharmacyError = "";
    thirdPartyAdminError = "";
  };

  const handleviewConfig = async () => {
    setRowConfig(false);
    setConfigRules(true);
    setClientCongigToggle(false);
    // await manvalConfig();
  };
  const handeldata = () => {
    console.log("krishna")
  }

   const hasPermission = (code) => {
      return ModuleAccess("CONFIG", code);
    };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={searchTerms}
      onSubmit={handleSubmit}
      enableReinitialize={true}
      children={(props) => {
        const { isSubmitting,
          handleSubmit,
          setFieldValue,
          errors,
          touched,
          setFieldTouched
        } = props;
        
        return (
          <div>
            <div className="d-flex justify-content-between">
              <h5 className="f-16 text-primary font-weight-700"> Search Configuration</h5>
              <div>
                <Button
                  // hidden={isAddPermission}
                  // disabled={isSubmitting}
                  // onClick={handleCEConfig}
                  onClick={handleviewConfig}
                  color="primary"
                  className="search"
                  disabled={isTPADisable || isCPDisable}
                  hidden={!hasPermission("ChainLevelConfig")}
                >
                  <span className="right_5">
                    <img src={configicon} alt="" />
                  </span>{" "}
                  Configurations
                </Button>
              </div>
            </div>
            <Row>
              <Col md={3} sm={3} xs={6}>
                {" "}
                <FormGroup>
                  <Label for="tpa">Third Party Administrator</Label>
                  <ThirdPartyAdmin
                    value={thirdPartyAdminID}
                    name='thirdPartyAdminID'
                    onChange={(value, tpa) =>
                      handleThirdPartyAdminChange(value, setFieldValue, tpa)
                    }
                  />
                  {
                    thirdPartyAdminError.length > 0
                      ? (
                        <div className="text-danger f-12 position-absolute">
                          {thirdPartyAdminError}
                        </div>
                      ) : null}
                </FormGroup>
              </Col>
              <Col md={3} sm={3} xs={6}>
                <FormGroup>
                  <Label for="chainPharmcy">Chain Pharmacy</Label>
                  <ReactSelect
                    name="chainPharmacyID"
                    id="chainPharmacyID"
                    options={chainPharmacyList}
                    isMulti={false}
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    optionSelected={true}
                    isClearable={true}
                    components={{
                      Option,
                      // ValueContainer: LimitedChipsContainer,
                    }}
                    isSearchable="true"
                    onChange={onSelectCP}
                    value={selectedOption.optionSelected}
                    className="required"
                    maxMenuHeight={220}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 99,
                      }),
                      option: (provided) => ({
                        ...provided,
                        display: 'flex',
                        alignItems: 'flex',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        alignItems: "start",
                        backgroundColor: 'transparent'
                      })
                    }}
                  />
                  {
                    chainPharmacyError.length > 0
                      ? (
                        <div className="text-danger f-12 position-absolute">
                          {chainPharmacyError}
                        </div>
                      ) : null}

                </FormGroup>
              </Col>
            </Row>
            <Row className="d-flex justify-content-end">
              <Col md="auto" className="mt-1">
                {/* <Label>{""}</Label> */}
                <Button
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                  color="primary"
                  className="search"
                >
                  <span className="right_5">
                    <img src={searchicon} alt="" />
                  </span>{" "}
                  Search
                </Button>
                <Button color="primary" className="reset" onClick={() => handleReset(props)}>
                  <span className="right_5">
                    <img src={reseticon} alt="" />
                  </span>{" "}
                  Reset
                </Button>
              </Col>
            </Row>
          </div>
        );
      }}
    ></Formik>
  );
};

export default SearchConfiguration;
